/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    string, func, object, oneOfType, shape, elementType, number,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import mbpLogger from 'mbp-logger';
import { useQuery } from 'react-apollo';
import PersonalizeImageCustoms from './PersonalizeImageCustoms';
import GraphqlPortalLoader from '../../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlPortalLoader';
import PersonalizeMessageCustoms from './PersonalizeMessageCustoms';
import PersonalizeImageAndMessageCustoms from './PersonalizeImageAndMessageCustoms';
import findContent from '../../../../../gql/queries/findContent';
import { DefaultTools } from '../../RTE/Config/Default';

const styles = () => ({
    saveButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '30px 0',
    },
    button: {
        padding: '6px 20px',
        marginRight: 40,
    },
});
const CUSTOMS_VIEWS = {
    SELECT_IMAGE: 'photo',
    SELECT_MESSAGE: 'text',
    SELECT_IMAGE_AND_MESSAGE: 'both',
};
const SelectCustoms = ({
    classes,
    customsCard,
    customsCardType,
    image,
    message,
    setImage,
    setMessage,
    personalizeCustomsCard,
    customCardStyling,
    imagePreviewCanvasRef,
    handleImage,
    customData,
    dataDictionary,
}) => {
    const contentAreaWidth = customData?.content_area_width;
    const conentAreaHeight  = customData?.content_area_height;
    const contentImageAreaWidth = customData?.message_image_settings?.image_width;
    const FONT_QUERY = findContent({
        brand: 'gci',
        contentType: 'fonts',
    });
    const { data, error, loading } = useQuery(FONT_QUERY);
    let response = null;
    if (loading) {
        response = <GraphqlPortalLoader />;
    }
    if (error) {
        mbpLogger.logError({
            query: FONT_QUERY,
            component: 'PersonalizeCustoms.js',
            message: 'Failed to fetch content data for: content type fonts, on brand gci',
            error,
        });
        response = null;
    }
    const toolsFontData = [];
    if (data) {
        const toolsData = data?.findContent?.content?.entries;
        DefaultTools.forEach((tool) => {
            if (tool.value === 'font') {
                const fontData =  toolsData?.map((font) => ({ maxChar: font.max_characters_labels, label: font.title, value: font.family_name }));
                toolsFontData.push({ ...tool, list: fontData });
            } else if (toolsFontData.filter((toolData) => toolData?.value === tool?.value).length === 0) {
                toolsFontData.push({ ...tool });
            }
        });
    }

    response = (
        <>
            {customsCardType === CUSTOMS_VIEWS.SELECT_IMAGE
                && (
                    <PersonalizeImageCustoms
                        customsCard={customsCard}
                        image={image}
                        setImage={setImage}
                        handleImage={handleImage}
                        imgWidth={contentAreaWidth}
                        imgHeight={conentAreaHeight}
                        imagePreviewCanvasRef={imagePreviewCanvasRef}
                        dataDictionary={dataDictionary}
                    />
                )}

            {customsCardType === CUSTOMS_VIEWS.SELECT_MESSAGE
                && (
                    <PersonalizeMessageCustoms
                        customsCard={customsCard}
                        message={message}
                        setMessage={setMessage}
                        csLabelData={customData}
                        toolbarProps={toolsFontData}
                    />
                )}
            {customsCardType === CUSTOMS_VIEWS.SELECT_IMAGE_AND_MESSAGE
                && (
                    <PersonalizeImageAndMessageCustoms
                        customsCard={customsCard}
                        image={image}
                        handleImage={handleImage}
                        message={message}
                        setImage={setImage}
                        setMessage={setMessage}
                        imgWidth={contentImageAreaWidth}
                        imgHeight={conentAreaHeight}
                        customCardStyling={customCardStyling}
                        imagePreviewCanvasRef={imagePreviewCanvasRef}
                        csLabelData={customData}
                        toolbarProps={toolsFontData}
                    />
                )}
            <Grid item xs={12} className={classes.saveButton}>
                <Button variant="contained" color="primary" className={classes.button} onClick={personalizeCustomsCard}>{dataDictionary?.['Review Label'] || 'Review Label'}</Button>
            </Grid>
        </>
    );
    return response;
};

SelectCustoms.propTypes = {
    classes: object.isRequired,
    customsCard: string.isRequired,
    customsCardType: string.isRequired,
    image: string.isRequired,
    message: string.isRequired,
    setImage: func.isRequired,
    setMessage: func.isRequired,
    personalizeCustomsCard: func.isRequired,
    customCardStyling: shape({
        image_width: number.isRequired,
        message_width: number.isRequired,
        space_between_message_image: number.isRequired,
    }).isRequired,
    handleImage: func.isRequired,
    imagePreviewCanvasRef: oneOfType([
        func,
        shape({ current: elementType }),
    ]).isRequired,
    customData: shape({
        content_area_width: string,
        content_area_height: string,
        message_image_settings: shape({
            image_width: string,
        }),
        message_settings: shape({
            heading_font_size: string,
        }),
    }).isRequired,
    dataDictionary: object,
};

SelectCustoms.defaultProps = {
    dataDictionary: {},
};

export default withStyles(styles)(SelectCustoms);
